import $ from 'jquery';
import plugin from '@core/plugins/lib';
import FormLoading from './form-loading';

const ELEMENT_SELECTOR = '[data-form-loading]';
const PLUGIN_NAME = 'FormLoading';

plugin(PLUGIN_NAME, FormLoading);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__form-loading/plugin--bundled.js